import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Money, Badge, statusTone, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { IndianRupee } from "lucide-react";
import { toast } from "sonner";

export default function AdminCommissions() {
  const { can } = useAuth();
  const [txns, setTxns] = useState([]);
  const [tab, setTab] = useState("pending");
  const load = useCallback(() => {
    api.get(`/admin/commissions?status=${tab === "all" ? "" : tab}`).then(({ data }) => setTxns(data));
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (t, status) => { await api.post(`/admin/commissions/${t.id}/status`, { status }); toast.success(`Marked ${status}`); load(); };

  return (
    <div data-testid="admin-commissions">
      <PageHeader title="Commissions" subtitle="Approve seller commissions" />
      <Tabs value={tab} onValueChange={setTab} className="mb-6">
        <TabsList><TabsTrigger value="pending">Pending</TabsTrigger><TabsTrigger value="approved">Approved</TabsTrigger><TabsTrigger value="available">Available</TabsTrigger><TabsTrigger value="withdrawn">Withdrawn</TabsTrigger><TabsTrigger value="all">All</TabsTrigger></TabsList>
      </Tabs>
      {txns.length === 0 ? <EmptyState icon={IndianRupee} title="No commissions" /> : (
        <div className="bg-white border border-border rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-muted-foreground"><tr><th className="p-4">Seller</th><th className="p-4">Course</th><th className="p-4">Sale</th><th className="p-4">Commission</th><th className="p-4">Status</th><th className="p-4">Action</th></tr></thead>
            <tbody>
              {txns.map((t) => (
                <tr key={t.id} className="border-t border-border" data-testid={`comm-${t.id}`}>
                  <td className="p-4 font-medium text-navy">{t.seller_name}</td>
                  <td className="p-4">{t.course_title}</td>
                  <td className="p-4"><Money amount={t.sale_amount} /></td>
                  <td className="p-4 font-semibold text-emerald-600"><Money amount={t.amount} /></td>
                  <td className="p-4"><Badge tone={statusTone(t.status)}>{t.status}</Badge></td>
                  <td className="p-4">
                    {can("commissions", "approve") && t.status === "pending" && <Button size="sm" onClick={() => setStatus(t, "approved")} className="viriks-navy text-white" data-testid={`approve-comm-${t.id}`}>Approve</Button>}
                    {can("commissions", "approve") && t.status === "approved" && <Button size="sm" onClick={() => setStatus(t, "available")} className="bg-emerald-600 text-white" data-testid={`avail-comm-${t.id}`}>Make Available</Button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
